// extracted by mini-css-extract-plugin
module.exports = {"sticky":"TrainHeader_sticky_s9lGX"};